module.exports = __webpack_public_path__ + "static/media/button-OpsManual.21074d58.png";